module.exports = __webpack_public_path__ + "img/03-01-img-01.a8132332.png";